module.exports = __webpack_public_path__ + "static/media/icon_quanly_buucuc.4b87a91f.svg";